import { Box, CircularProgress,useTheme } from "@mui/material";

const DataLoader = () => {
    const theme = useTheme();
    return (
        <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
        }}>
            <CircularProgress size="3rem" sx={{color:theme.palette.mode === "dark" ? "#fff" : "#2E3B80"}}/>
        </Box>
    )
};


export default DataLoader;